import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useParams } from 'react-router-dom';
import { ThingViewArbitrator } from '../../ArbitrationObjects/ThingViewArbitrator';
import { ObjectViewType } from '../../types/AppTypes';
import DefaultThingsView from '../DefaultThingsViewV3';
const debug = process.env.REACT_APP_DEBUG && false;
function ThingsViews(props) {
    const { thingViewMap, useSpecializedViews, contextCustomer } = props;
    /**
     * 2024 02 context object. If this is undefined, list will be 'All of', if contextObject: contextCustomer it will be limited to customer etc.
     * A contextObject is needed for Add and Link functions.
     */
    const params = useParams();
    const objectTypeId = params.type;
    const constrainedParameters = { objectTypeId };
    debug && console.log(`ThingsView with objectTypeId ${objectTypeId} props`, props);
    debug && console.log(`ThingsView`, { contextCustomer, objectTypeId, thingViewMap });
    let SelectedClass = null;
    if (contextCustomer && objectTypeId && thingViewMap) {
        const thingsViewArbitratorInput = {
            thingViewMap,
            objectTypeId: objectTypeId,
            objectViewType: ObjectViewType.List,
            useSpecializedViews,
        };
        SelectedClass = ThingViewArbitrator(thingsViewArbitratorInput);
        debug && console.log('ThingsView', 'Selected Component', SelectedClass);
    }
    const SelectedComponent = SelectedClass ? (_jsx(SelectedClass, { ...{ ...props, viewObjects: [], classes: {}, appRef: { current: null } } }, contextCustomer?.id)) : null;
    return SelectedComponent ?? _jsx(DefaultThingsView, { ...props, params, viewObjects: [], constrainedParameters }, contextCustomer?.id);
}
export default ThingsViews;
